import { INVALID_COMBINATIONS } from './constants';

type InvalidCombination = {
  region?: string;
  countryCode?: string;
  business?: string;
};

type RequestLike = {
  region?: string;
  countryCode?: string;
  business?: string;
  status?: string | null;
};

function isValidRequest(request: RequestLike | null | undefined, invalidCombos?: InvalidCombination[]) {
  if (!request) return false;

  if (request.status && request.status.toLowerCase() === 'pending') {
    return false;
  }

  if (!invalidCombos?.length) return true;

  const isInvalid = invalidCombos.some(
    combo =>
      combo.region === request.region &&
      combo.countryCode === request.countryCode &&
      combo.business === request.business
  );

  return !isInvalid;
}

export const filterValidRequests = <T extends RequestLike>(
  requests: Array<T | null | undefined>,
  invalidCombos: InvalidCombination[] = INVALID_COMBINATIONS
): T[] => requests.filter((req): req is T => isValidRequest(req, invalidCombos));
